import { render } from "./ResetPasswordForm.vue?vue&type=template&id=71ca04d2"
import script from "./ResetPasswordForm.vue?vue&type=script&lang=js"
export * from "./ResetPasswordForm.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/htdocs/cgeolink/src/front/cgeolink/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__